import { formatDecimal } from "@/common/utils/formatters";
import { CardsTotalizerData } from "../../types/cardsTotalizer.type";

const CardsTotalizerResume = ({ cardsTotalizer }: { cardsTotalizer: CardsTotalizerData }) => {
  return (
    <div className="flex gap-6">
      <div>
        <p className={`font-light italic text-[14px]`}>Total em cartões</p>
        <p className={`text-[18px]`}>{formatDecimal(Number(cardsTotalizer?.total || 0), 0)}</p>
      </div>

      <div>
        <p className={`font-light italic text-[14px] text-valid`}>Cartões ativos</p>
        <p className={`text-[18px] text-valid`}>{formatDecimal(Number(cardsTotalizer?.per_status?.active || 0), 0)}</p>
      </div>

      <div>
        <p className={`font-light italic text-[14px] text-yellow-400`}>Cartões bloqueados</p>
        <p className={`text-[18px] text-yellow-400`}>{formatDecimal(Number(cardsTotalizer?.per_status?.blocked || 0), 0)}</p>
      </div>
    </div>
  );
};

export default CardsTotalizerResume;
